import React from "react";
import "./about.scss";
// Components
import Title from "../ui-components/title/title";
// Assets

const about = () => (
  <div id="about">
    <div className="wrapper">
      <Title title="ABOUT US" />
      <p className="info">
        We are a global software company dedicated to delivering clean, performant code at competitive prices. 
        Our team specializes in building scalable, reliable solutions for clients worldwide, leveraging the latest technologies and best practices.
      </p>
      <br></br>
      <div className="desktopSkills">
        <p><b>Core Services:</b> Custom Software Development, Web & Mobile Applications, Cloud Solutions, DevOps, API Integration, AI Services</p>
        <p><b>AI Services:</b> Integrating AI agents into legacy code, Building new AI tools and solutions</p>
        <p><b>Technologies:</b> JavaScript, React, Node.js, Python, Golang, Java, Docker, Kubernetes, AWS, Azure, GCP</p>
        <p><b>Quality Assurance:</b> Automated Testing, Code Reviews, Performance Optimization</p>
        <p><b>Delivery:</b> Agile Methodologies, Transparent Communication, On-Time Project Completion</p>
        <p><b>Global Reach:</b> Serving clients across North America, Europe, Asia, and beyond</p>
        <p><b>Competitive Pricing:</b> Flexible engagement models tailored to your business needs</p>
        <p><b>Collaboration:</b> Jira, Slack, GitHub, Bitbucket</p>
      </div>
      <div className="mobileSkills">
        <p><b>Core Services</b></p> <p> Custom Software, Web & Mobile Apps, Cloud, DevOps, API Integration, AI Services</p>
        <p><b>AI Services</b></p> <p> AI agent integration, New AI tool development</p>
        <p><b>Technologies</b></p> <p> JavaScript, React, Node.js, Python, Golang, Java, Docker, Kubernetes, AWS, Azure, GCP</p>
        <p><b>Quality Assurance</b></p> <p> Automated Testing, Code Reviews, Performance Optimization</p>
        <p><b>Delivery</b></p> <p> Agile, Transparent Communication, On-Time Completion</p>
        <p><b>Global Reach</b></p> <p> North America, Europe, Asia, and more</p>
        <p><b>Competitive Pricing</b></p> <p> Flexible models for your needs</p>
        <p><b>Collaboration</b></p> <p> Jira, Slack, GitHub, Bitbucket</p>
      </div>
    </div>
  </div>
);

export default about;
